import {
    GetPersonalPhoneNumbersQuery,
    useGetPersonalPhoneNumbersQuery,
} from "generated/graphql";
import { useMemo } from "react";
import { stableQueryOptions } from "util/requests";
import { useFeature } from "./hooks";

const fiveMinutes = 5 * 60 * 1000;

export const usePhoneLines =
    (): GetPersonalPhoneNumbersQuery["getPersonalPhoneNumbers"] => {
        const enabled = useFeature("sms");

        const getPersonalNumbers = useGetPersonalPhoneNumbersQuery(
            {},
            {
                ...stableQueryOptions(),
                enabled,
                refetchInterval: fiveMinutes,
            },
        );

        const sendingNumbers = useMemo(() => {
            return getPersonalNumbers.data?.getPersonalPhoneNumbers ?? [];
        }, [getPersonalNumbers.data]);

        return sendingNumbers;
    };
